/*! Wi-alerts - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */
var url_user;
var alertIterator = 1;
var alertIdCounter = 0;
+function ($) {
    'use strict';
    var wiAlerts = window.wiAlerts;
    var html = '<div id="alerts-wrapper"></div>';
    window.wiAlerts = {
        init: function () {
            wiAlerts.events();
            wiAlerts.flash.init();
        },
        refresh: function () {
        },
        flash: {
            init: function () {
                wiAlerts.flash.get();
            },
            get: function () {
                $.get(url_user + '/flash-msg', function (data) {
                    if (data.user_success) {
                        wiAlerts.flash.process(data.user_success);
                    }
                    if (data.user_info) {
                        wiAlerts.flash.process(data.user_info);
                    }
                    if (data.user_danger) {
                        wiAlerts.flash.process(data.user_danger);
                    }
                    if (data.user_warning) {
                        wiAlerts.flash.process(data.user_warning);
                    }
                    if (data.success) {
                        wiAlerts.flash.process(data.success);
                    }
                    if (data.info) {
                        wiAlerts.flash.process(data.info);
                    }
                    if (data.danger) {
                        wiAlerts.flash.process(data.danger);
                    }
                    if (data.warning) {
                        wiAlerts.flash.process(data.warning);
                    }
                    if (data.flash) {
                        $(data.flash).insertAfter('#navbar-main');
                    }
                });
            },
            process: function (data) {
                $.each(data, function (i, alert) {
                    ++alertIterator;
                    wiAlerts.add(alert.type, alert.title, alert.message);
                });
            }
        },
        add: function (type, title, message) {
            var uId = wiAlerts.uniqueId('alert_');
            var message_title = '';
            if(title){
                var message_title = '<strong>' + title + '</strong> ';
            }
            var alert = '<div id="' + uId + '" class="alert alert-' + type + ' alert-dismissable"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>' + message_title + message + '</div>';

            if (!$('#alerts-wrapper').length) {
                $('body').append(html);
            }
            var delay = 5000;
            if (alertIterator) {
                delay = 5000 * alertIterator;
            }
            $(alert).appendTo('#alerts-wrapper');
            setTimeout(function () {
                $('#' + uId).remove();
            }, delay);
        },
        uniqueId: function (prefix) {
            var id = ++alertIdCounter + '';
            return prefix ? prefix + id : id;
        },
        events: function () {
            $(document).on('closed.bs.alert', '.alert', function () {
                $(this).remove();
            });

        }
    };
    $(function () {
        url_user = urls.user;
        wiAlerts = window.wiAlerts;
        wiAlerts.init();
    });
}(jQuery);
